var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskSplashLayout",
    {
      nativeOn: {
        click: function($event) {
          return _vm.handleClick($event)
        }
      }
    },
    [
      _c("h1", [
        _c("span", [_vm._v("TOUCH SCREEN ")]),
        _vm._v("To Boss Your Burger")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskMain.vue?vue&type=template&id=b811a27a&
// module id = null
// module chunks = 